import React from "react";
import { Button, FloatButton } from "antd";
import {LineChartOutlined} from "@ant-design/icons";
function Jbrowse() {
  const [IsShowJbrowse, setIsShowJbrowse] = React.useState("NNU");
  const IsShowJbrowseFn = () => {
    if (IsShowJbrowse === "NNU") {
      return (
        <iframe
          src="http://182.92.235.125:18888/api/JBrowse2/?config=lotus%2Fconfig%2Fconfig.json&session=encoded-eJyFlF1X4jAQhv9LrllPq_jFHeIqHhFRWGF3jxdpO20jadJNAgU9_PedtLEFVt27ZmYyH0_m7RuJFC1AjaRmhklBOoRDbEjL2acsMinpHJ21W6RgUQJGk84buVYsupBynlE1t2cW4cUdY4uYdQ571mmZgWxaJGWgqApTFlI-UTScj4FDaKSqs30eUafufxbi6rTIkkGBgT5bna-geCzyQTHL9MNcvvBf6I5pCAYiWzNm3ICawMpgPLp0KotxTpXGQjHlGirTVRmGDIxaONN9bsHpOiynArjj1va8zQbHpaFhS5g2AL-Y_wsfZsqYYBl7tU27eiUt9XgymXmz4ix8fbhJw-LI6wYCxxA0s6SGwx94wCdIGD6xV4HBRn472J8B-reaQz9gAqi6BiEzeLKQW0TGsQYzWpHOafvQw30J8hEuFp59z_cP_KPDk2O_3T7Hj2NcL6ZzTtcQPUJS4cNeFCwR7lY1BfGwmqCXKs-372KoMuUIIDDu0D89RsgenqnWkAV8PaxHPkjK_sjmGfu2ILcm7l9e3666S6X5y_dCz-L2nynzmtW6AmoWCkr8aA2liFmyUNRppEl-kMTxh6DcgFslX-lgOU7uHq786R2c3I5efvKnAdlDekE1Cy-ru-hLgSWpGSnolR3gwKfn_2vn2weZNs8WQsoi6AONQNVtNqZ7ZF_pZcs1lCUC3S0XuNmC7bWcVP1vr60TUA8EqsW2syOi3trIgIpIj8EYJpJ3NZVZBzQArhsR2v8Hxwy15lIkwi0VJPtsWXCpLta9y_FOjbLt-4XZuRq4_1D_PYV-YpoFHPYDqiZ2nJafBq2R-OR9lxpTt1o-Bs5sIMsl4ljvO_DpBFLDKzcCd1mEsJuoV_udPZbhAiVhRXbzlVTd_RFfoMbLu5u_W-sMWw&wework_cfm_code=MBQFuBa3cLWlLpfYvb6lPRZyeKjN5aWmTg7%2FMrA6nvXhtxogTpMlcWTXzg6PuKxo1UwlZQG%2BYyUxxz4hKgDiZ8rC%2FF3uNASSbkHt%2FmmOdOHLtsmATdDQfVNdPZyi0EPqTVeysPahdNEGT%2BLeJ5VzkqEnT8SxIEdViXqN6gnCLjYTgOvd4toJaZv00PdnEQYgcvRqUmfGy%2FVRRmfZy4U8u6wTeFtUMcmXSn7yH30xRxX1MG%2BElheMHozsAg4wXlc6d5YuYRGdGDHMxkp7W3QF1QN3zt8COC9JWFQtkKqOhS0ZU%2FaTa%2FPgzFq9BvWKNWPxGjkWvBHzErg5D9D2snrNhoIIegaIaigpfwxuOoybGEamQrpJ9WLmy5yvLsqKay1HIikeG9u7kYWA75wpezO52qpJ7%2BxzUj3DHOW44PIvo7L1"
          style={{
            width: "100%",
            height: "100%",
          }}
        ></iframe>
      );
    } else if (IsShowJbrowse === "NLU") {
      return (
        <iframe
          src="http://182.92.235.125:18888/api/JBrowse2/?config=lotus%2Fconfig%2Fconfig.json&session=encoded-eJyFlG1T4jAQx79LXqNDaanCO6yncMcACoozN44T2m2bIzSdJAWrw3e_TVtb4NR72X387y-7fSeBpDuQM6GYZiIhfcIh1KRV2Zcs0DHp2xfdFtmxIAKtSP-d3EoWXAmx3lC5Nt8swMQjY4voPIUT67KoQPYtEjOQVPox8ylfSOqv58DB10LW1b6OqEsPvwqp-rTIlsEOA5e7xfqMpT_F3cza8qnLRukFR3dIfdAQmJ4h4xrkAl41xqNLxWI3T6lU2CikXEFpuinCkIGWWWWapgacqsNSmgCvuDnt9n6P41Jfsy0sG4DfzP-NDyttWMI27M2IrvoVtF6cPEhl-rpz72E8WaZ3bw-dFxwjoRtDajJ-wA98gojhE7dLMCjkdwX7K0D_dqvQj1kCVN5CIjbwaCC3iAhDBXr2SvqW3Xa7vRZZpTPcLDQ47uV5-7Jn9y5d1-padtfB_WIq5TSH4B6ikh-KkbBFugftJISTcgQ_lpZ5F02lLkaABMM6HctxLcfGb6oUbFY8n9Qjn0eFPrJ_Rt0G5MHEvn3vuMPYy8YQjp6eOj_sP57XrNYNUJ1JKPCj1RdJyKJM0upGmuLnURh-Cqqa76Dlg_h1C4P21tW9Xxfqjg_SMJ2SE6RXVDH_usxFXwwsivVMglcowIFd-39yzj6ptH82EGIWwBBoALKW2ZimiL68lwPXRBQI1KBY4GYLDtdyUeo_XNvqgDxI8FqMnKMj8nItVjQJ1By0Zkn0cU1F1TFdAVfNEZr_B8cK9c3FSIQbKkj22bDgQl7l3vX8qEche5rpo9RV9R8afpRQj0yxFYfTgFLEkdPwU6AUEl987FJjGpTLx6Aya9ikAnHkpw58ugSpYcoowV1OfDgu5NX-yh4KP8OLMEc2-u5Uq_wZz_DGi9z9X52BCWY&wework_cfm_code=MBQFuBa3cLWlLpfYvb6lPRZyeKjN5aWmTg7%2FMrA6nvXhtxogTpMlcWTXzg6PuKxo1UwlZQG%2BYyUxxz4hKgDiZ8rC%2FF3uNASSbkHt%2FmmOdOHLtsmATdDQfVNdPZyi0EPqTVeysPahdNEGT%2BLeJ5VzkqEnT8SxIEdViXqN6gnCLjYTgOvd4toJaZv00PdnEQYgcvRqUmfGy%2FVRRmfZy4U8u6wTeFtUMcmXSn7yH30xRxX1MG%2BElheMHozsAg4wXlc6d5YuYRGdGDHMxkp7W3QF1QN3zt8COC9JWFQtkKqOhS0ZU%2FaTa%2FPgzFq9BvWKNWPxGjkWvBHzErg5D9D2snrNhoIIegaIaigpfwxuOoybGEamQrpJ9WLmy5yvLsqKay1HIikeG9u7kYWA75wpezO52qpJ7%2BxzUj3DHOW44PIvo7L1"
          style={{
            width: "100%",
            height: "100%",
          }}
        ></iframe>
      );
    }
  };
  return (
    <div style={{ width: "100%", height: "99%" }}>
      <FloatButton
      icon={<LineChartOutlined />}
        tooltip={
          <div style={{ display: "flex", flexDirection: "column" }}>
            <Button
              style={{ margin: "10px 0",
                background:IsShowJbrowse=='NNU'?"#BDF7C1":"",
                border:"none"
               }}
              onClick={() => {
                setIsShowJbrowse("NNU");
              }}
            >
              NNU
            </Button>
            <Button
              style={{ margin: "10px 0",
                 background:IsShowJbrowse=='NLU'?"#BDF7C1":"",
                border:"none"

               }}
              onClick={() => {
                setIsShowJbrowse("NLU");
              }}
            >
              NLU
            </Button>
          </div>
        }
        style={{
          position: "fixed", // 确保使用固定定位
          right: "24px", // 距离右侧的距离
          bottom: "50px", // 确保底部不生效
        }}
      />
      {
        IsShowJbrowseFn()
      }
    </div>
  );
}

export default Jbrowse;
